import { useState } from "react";
import "../assets/css/Contact.css";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

const contact = [
  {
    icon: <FaPhoneAlt />,
    label: "Phone",
    val: "(+91) 8428010909",
    sub: "(+91) 8428110909",
    btn: "Call Now",
  },
  {
    icon: <FaEnvelope />,
    label: "Email",
    val: "Support@skimitarhindusthan.com",
    sub: "",
    btn: "Send Email",
  },
  {
    icon: <FaMapMarkerAlt />,
    label: "Address",
    val: "1st Floor, D.No:027,Ward 25th, 2nd Cross, Annamalai Layout, Nalli Hospital Road",
    sub: "Erode -638011, Tamil Nadu, India",
    btn: "View Map",
  },
  // {
  //   icon: require("../assets/img/Contact/icon-4.png"),
  //   label: "Business Hours",
  //   val: "Mon – Sat",
  //   sub: "9:00 AM – 6:00 PM",
  // },
];

const faqs = [
  {
    q: "How quickly will I receive a response after submitting the form?",
    a: "Our team typically responds within 24 business hours. For urgent matters, call us at (+91) 8428010909 or (+91) 8428110909 during business hours.",
  },
  {
    q: "Do you offer online training programs?",
    a: "Yes! All our training programs are available in both online and classroom formats. You can attend live online sessions from anywhere in India or join our in-person batches at our Erode training centre.",
  },
  {
    q: "Can you deliver services and training outside Erode?",
    a: "Absolutely. We provide pan-India service delivery and on-site corporate training across all major states including Tamil Nadu, Karnataka, Andhra Pradesh, Maharashtra, Kerala and more.",
  },
  {
    q: "Do you provide placement assistance after course completion?",
    a: "Yes, we offer dedicated placement support including resume building, mock interview sessions, career counselling, and direct job referrals to our industry partner network.",
  },
  {
    q: "How can I enroll in a corporate training program for my team?",
    a: "Fill out the contact or quote form above and select 'Corporate Training'. Our training team will reach out to understand your team's needs and design a customized program for you.",
  },
  {
    q: "What is the office address of Skimitar Hindusthan?",
    a: "We are located at: 1st Floor, D.No: 027, Ward 25th, 2nd Cross, Annamalai Layout, Nalli Hospital Road, Erode – 638011, Tamil Nadu, India.",
  },
];

const socialLinks = [
  { icon: "📘", name: "Facebook", handle: "Skimitar Official" },
  { icon: "▶️", name: "YouTube", handle: "Skimitar Official" },
  { icon: "💼", name: "LinkedIn", handle: "Skimitar Hindusthan" },
  { icon: "📸", name: "Instagram", handle: "Skimitar Official" },
];

const quoteReasons = [
  {
    icon: "⚡",
    title: "Fast Response",
    desc: "Our team responds to all quote requests within 24 business hours with a detailed proposal.",
  },
  {
    icon: "💰",
    title: "Transparent Pricing",
    desc: "No hidden charges — clear, itemized quotes tailored to your specific requirements.",
  },
  {
    icon: "🎯",
    title: "Customized Solutions",
    desc: "Every quote is customized — whether it's a project, service, or training program.",
  },
  {
    icon: "🤝",
    title: "Free Consultation",
    desc: "All new enquiries include a free 30-minute consultation call with our domain experts.",
  },
  {
    icon: "🌍",
    title: "Pan-India Service",
    desc: "We serve clients and learners across India — online and on-site wherever you are.",
  },
];

export default function Contact() {
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (i) => setOpenFaq(openFaq === i ? null : i);

  return (
    <>
      {/* Hero */}
      <div
        className="text-center mb-4 d-flex flex-column justify-content-center align-items-center"
        style={{
          backgroundImage:
            "linear-gradient(rgba(0, 0, 0, 0.86), rgba(0, 0, 0, 0.86)), url(" +
            require("../assets/img/Contact/banner.jpg") +
            ")",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "60vh",
        }}
      >
        <span
          className="badge mb-3 px-3 py-2"
          style={{
            background: "#cc0000",
            fontSize: "11px",
            letterSpacing: "0.5px",
          }}
        >
          Contact Us
        </span>

        <h1 className="text-white fw-medium fs-4 mb-3">
          Let's Start a Conversation
        </h1>

        <p
          className="mx-auto mb-0"
          style={{
            color: "#ffffff",
            fontSize: "15px",
            lineHeight: "1.8",
            maxWidth: "520px",
          }}
        >
          Whether you're looking for a technology solution, a training program,
          or simply want to learn more — we're here and ready to help. Reach us
          anytime.
        </p>
      </div>

      {/* Info Strip */}
      <div className="container container_width mt-5">
        <div className="row g-4 justify-content-center align-items-stretch">
          {contact.map((data, i) => (
            <div
              key={i}
              className="col-12 col-sm-6 col-lg-4"
              // data-aos="fade-up"
              // data-aos-delay={i * 150}
            >
              <div
                className="card h-100 border-0 shadow rounded-4 text-center p-5 transition-all hover-card"
                style={{
                  transition: "all 0.3s ease",
                }}
              >
                {/* Icon Container */}
                <div
                  className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-4"
                  style={{
                    width: "85px",
                    height: "85px",
                    background: "linear-gradient(135deg, #cc0000, #e63939)",
                  }}
                >
                  <div
                    style={{
                      width: "38px",
                      height: "38px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      filter: "brightness(0) invert(1)",
                    }}
                  >
                    {data.icon}
                  </div>
                </div>

                {/* Title */}
                <h5
                  className="fw-bold mb-3 text-dark"
                  style={{ fontSize: "1.35rem" }}
                >
                  {data.label}
                </h5>

                {/* Content */}
                <div className="mb-4">
                  <p
                    className="text-muted mb-1"
                    style={{ fontSize: "15px", lineHeight: "1.6" }}
                  >
                    {data.val}
                  </p>
                  {data.sub && (
                    <p
                      className="text-muted small mb-0"
                      style={{ fontSize: "14px" }}
                    >
                      {data.sub}
                    </p>
                  )}
                </div>

                {/* Button */}
                <div className="mt-auto">
                  <button
                    className="btn btn-outline-danger rounded-pill px-5 py-2.5 fw-medium w-100"
                    style={{
                      borderWidth: "1.5px",
                      fontSize: "14.5px",
                      transition: "all 0.3s ease",
                    }}
                    onMouseOver={(e) => {
                      e.target.style.backgroundColor = "#cc0000";
                      e.target.style.color = "#fff";
                      e.target.style.borderColor = "#cc0000";
                    }}
                    onMouseOut={(e) => {
                      e.target.style.backgroundColor = "transparent";
                      e.target.style.color = "#cc0000";
                      e.target.style.borderColor = "#cc0000";
                    }}
                  >
                    {data.btn}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Contact Form + Right */}
      <div className="mb-5">
        <p
          className="text-uppercase fw-medium mb-1"
          style={{ fontSize: "11px", color: "#cc0000", letterSpacing: "1px" }}
        >
          Get in Touch
        </p>
        <h2 className="fw-medium mb-2" style={{ fontSize: "18px" }}>
          We'd Love to Hear From You
        </h2>
        <p
          className="text-secondary mb-4"
          style={{ fontSize: "12px", lineHeight: "1.7" }}
        >
          Fill in the form below or reach us directly — our team will get back
          to you within 24 hours.
        </p>

        <div className="row g-4">
          {/* Form */}
          <div className="col-12 col-lg-7">
            <div className="card border p-4 h-100">
              <p
                className="fw-medium border-bottom pb-3 mb-3"
                style={{ fontSize: "14px" }}
              >
                ✉️ Send Us a Message
              </p>
              <div className="row g-3 mb-3">
                <div className="col-12 col-sm-6">
                  <label
                    className="form-label text-secondary fw-medium"
                    style={{ fontSize: "11px" }}
                  >
                    Full Name *
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Your full name"
                    style={{ fontSize: "12px" }}
                  />
                </div>
                <div className="col-12 col-sm-6">
                  <label
                    className="form-label text-secondary fw-medium"
                    style={{ fontSize: "11px" }}
                  >
                    Phone Number *
                  </label>
                  <input
                    type="tel"
                    className="form-control"
                    placeholder="+91 XXXXX XXXXX"
                    style={{ fontSize: "12px" }}
                  />
                </div>
              </div>
              <div className="mb-3">
                <label
                  className="form-label text-secondary fw-medium"
                  style={{ fontSize: "11px" }}
                >
                  Email Address *
                </label>
                <input
                  type="email"
                  className="form-control"
                  placeholder="your@email.com"
                  style={{ fontSize: "12px" }}
                />
              </div>
              <div className="mb-3">
                <label
                  className="form-label text-secondary fw-medium"
                  style={{ fontSize: "11px" }}
                >
                  I'm Interested In
                </label>
                <select className="form-select" style={{ fontSize: "12px" }}>
                  <option>Select an option</option>
                  <option>Industrial Automation Services</option>
                  <option>Embedded Systems & IIoT</option>
                  <option>IT & Software Development</option>
                  <option>Digital Marketing Services</option>
                  <option>Certification Courses</option>
                  <option>Internship Program</option>
                  <option>Corporate Training</option>
                  <option>Seminar & Workshop</option>
                  <option>Live Project Work</option>
                  <option>General Enquiry</option>
                </select>
              </div>
              <div className="mb-0">
                <label
                  className="form-label text-secondary fw-medium"
                  style={{ fontSize: "11px" }}
                >
                  Your Message
                </label>
                <textarea
                  className="form-control"
                  rows={4}
                  placeholder="Tell us more about your requirement..."
                  style={{ fontSize: "12px" }}
                />
              </div>
              <button
                className="btn w-100 text-white mt-3 fw-medium"
                style={{ background: "#cc0000", fontSize: "13px" }}
              >
                Send Message →
              </button>
              <p
                className="text-center text-secondary mt-2 mb-0"
                style={{ fontSize: "10px" }}
              >
                We respect your privacy. Your information will never be shared.
              </p>
            </div>
          </div>

          {/* Right col */}
          <div className="col-12 col-lg-5 d-flex flex-column gap-3">
            {/* Map */}
            <div className="card border overflow-hidden">
              <div className="card-body border-bottom">
                <p className="fw-medium mb-1" style={{ fontSize: "13px" }}>
                  📍 Skimitar Hindusthan Pvt Ltd
                </p>
                <p
                  className="text-secondary mb-0"
                  style={{ fontSize: "11px", lineHeight: "1.5" }}
                >
                  1st Floor, D.No: 027, Ward 25th, 2nd Cross,
                  <br />
                  Annamalai Layout, Nalli Hospital Road,
                  <br />
                  Erode – 638011, Tamil Nadu, India
                </p>
              </div>
              <div
                className="d-flex flex-column align-items-center justify-content-center py-4"
                style={{ background: "#f8f9fa" }}
              >
                <span style={{ fontSize: "28px" }}>🗺️</span>
                <a
                  href="#"
                  className="fw-medium mt-2 text-decoration-none"
                  style={{ fontSize: "12px", color: "#cc0000" }}
                >
                  View on Google Maps →
                </a>
              </div>
            </div>

            {/* Hours */}
            <div className="card border p-3">
              <p className="fw-medium mb-3" style={{ fontSize: "12px" }}>
                🕐 Business Hours
              </p>
              {[
                {
                  day: "Monday – Friday",
                  time: "9:00 AM – 6:00 PM",
                  closed: false,
                },
                { day: "Saturday", time: "9:00 AM – 4:00 PM", closed: false },
                { day: "Sunday", time: "Closed", closed: true },
              ].map(({ day, time, closed }) => (
                <div
                  key={day}
                  className="d-flex justify-content-between align-items-center border-bottom py-2"
                  style={{ fontSize: "12px" }}
                >
                  <span className="text-secondary">{day}</span>
                  <span
                    className={closed ? "fw-medium" : "fw-medium"}
                    style={closed ? { color: "#E24B4A" } : {}}
                  >
                    {time}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Social Media */}
      <div className="mb-5">
        <p
          className="text-uppercase fw-medium mb-1"
          style={{ fontSize: "11px", color: "#cc0000", letterSpacing: "1px" }}
        >
          Follow Us
        </p>
        <h2 className="fw-medium mb-2" style={{ fontSize: "18px" }}>
          Stay Connected on Social Media
        </h2>
        <p
          className="text-secondary mb-4"
          style={{ fontSize: "12px", lineHeight: "1.7" }}
        >
          Follow us for the latest updates, course announcements, project
          highlights, and industry insights.
        </p>
        <div className="row g-3">
          {socialLinks.map(({ icon, name, handle }) => (
            <div className="col-6 col-sm-3" key={name}>
              <div
                className="card border text-center p-3 h-100"
                style={{ cursor: "pointer" }}
              >
                <div style={{ fontSize: "20px" }}>{icon}</div>
                <p className="fw-medium mt-2 mb-1" style={{ fontSize: "12px" }}>
                  {name}
                </p>
                <p className="text-secondary mb-0" style={{ fontSize: "11px" }}>
                  {handle}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Get a Quote */}
      {/* <div className="mb-5">
        <p
          className="text-uppercase fw-medium mb-1"
          style={{ fontSize: "11px", color: "#cc0000", letterSpacing: "1px" }}
        >
          Get a Quote
        </p>
        <h2 className="fw-medium mb-2" style={{ fontSize: "18px" }}>
          Request a Free Consultation or Quote
        </h2>
        <p
          className="text-secondary mb-4"
          style={{ fontSize: "12px", lineHeight: "1.7" }}
        >
          Tell us about your project or training requirement and we'll get back
          to you with the best solution and pricing.
        </p>
        <div className="row g-4">
          <div className="col-12 col-lg-6">
            <div className="card border p-4 h-100">
              <p
                className="fw-medium border-bottom pb-3 mb-3"
                style={{ fontSize: "14px" }}
              >
                📋 Quick Quote Request
              </p>
              <div className="mb-3">
                <label
                  className="form-label text-secondary fw-medium"
                  style={{ fontSize: "11px" }}
                >
                  Your Name *
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Full name"
                  style={{ fontSize: "12px" }}
                />
              </div>
              <div className="mb-3">
                <label
                  className="form-label text-secondary fw-medium"
                  style={{ fontSize: "11px" }}
                >
                  Company / Institution
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Company or college name"
                  style={{ fontSize: "12px" }}
                />
              </div>
              <div className="mb-3">
                <label
                  className="form-label text-secondary fw-medium"
                  style={{ fontSize: "11px" }}
                >
                  Service / Course Required *
                </label>
                <select className="form-select" style={{ fontSize: "12px" }}>
                  <option>Select a domain</option>
                  <option>Industrial Automation</option>
                  <option>Embedded Systems & IIoT</option>
                  <option>IT & Software Development</option>
                  <option>Digital Marketing</option>
                  <option>Certification Course</option>
                  <option>Corporate Training</option>
                  <option>Internship / Project</option>
                </select>
              </div>
              <div className="mb-0">
                <label
                  className="form-label text-secondary fw-medium"
                  style={{ fontSize: "11px" }}
                >
                  Brief Requirement
                </label>
                <textarea
                  className="form-control"
                  rows={4}
                  placeholder="Describe your requirement briefly..."
                  style={{ fontSize: "12px" }}
                />
              </div>
              <button
                className="btn w-100 text-white mt-3 fw-medium"
                style={{ background: "#cc0000", fontSize: "13px" }}
              >
                Request a Quote →
              </button>
            </div>
          </div>

          <div className="col-12 col-lg-6">
            <div className="d-flex flex-column gap-3 h-100">
              {quoteReasons.map(({ icon, title, desc }) => (
                <div key={title} className="card border p-3">
                  <p className="fw-medium mb-1" style={{ fontSize: "12px" }}>
                    {icon} {title}
                  </p>
                  <p
                    className="text-secondary mb-0"
                    style={{ fontSize: "11px", lineHeight: "1.5" }}
                  >
                    {desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div> */}

      {/* FAQ */}
      <div className="mb-5">
        <p
          className="text-uppercase fw-medium mb-1"
          style={{ fontSize: "11px", color: "#cc0000", letterSpacing: "1px" }}
        >
          FAQ
        </p>
        <h2 className="fw-medium mb-3" style={{ fontSize: "18px" }}>
          Frequently Asked Questions
        </h2>
        <div className="d-flex flex-column gap-2">
          {faqs.map((faq, i) => (
            <div key={i} className="card border overflow-hidden">
              <button
                className="d-flex justify-content-between align-items-center w-100 bg-transparent border-0 text-start p-3 fw-medium"
                onClick={() => toggleFaq(i)}
                style={{
                  fontSize: "12px",
                  color: openFaq === i ? "#cc0000" : "inherit",
                  cursor: "pointer",
                }}
              >
                <span>{faq.q}</span>
                <span
                  className="ms-3 text-secondary flex-shrink-0"
                  style={{
                    fontSize: "12px",
                    transition: "transform 0.2s",
                    transform:
                      openFaq === i ? "rotate(180deg)" : "rotate(0deg)",
                    display: "inline-block",
                  }}
                >
                  ▼
                </span>
              </button>
              {openFaq === i && (
                <div
                  className="px-3 pb-3 text-secondary"
                  style={{ fontSize: "12px", lineHeight: "1.7" }}
                >
                  {faq.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* CTA Banner */}
      <div
        className="rounded-3 text-center py-5 px-3"
        style={{ background: "#1a1a1a" }}
      >
        <h2 className="text-white fw-medium mb-3" style={{ fontSize: "18px" }}>
          Still Have Questions? We're Here to Help.
        </h2>
        <p
          className="mx-auto mb-4"
          style={{
            color: "#aaa",
            fontSize: "12px",
            lineHeight: "1.7",
            maxWidth: "500px",
          }}
        >
          Reach out to our team directly — we're always happy to assist with any
          enquiry, big or small.
        </p>
        <div className="d-flex flex-wrap justify-content-center gap-2 mb-3">
          <button
            className="btn text-white fw-medium px-4"
            style={{ background: "#cc0000", fontSize: "12px" }}
          >
            📞 (+91) 8428010909
          </button>
          <button
            className="btn px-4"
            style={{
              background: "transparent",
              color: "#fff",
              border: "0.5px solid #555",
              fontSize: "12px",
            }}
          >
            ✉️ Support@skimitarhindusthan.com
          </button>
        </div>
        <p style={{ color: "#666", fontSize: "11px" }}>
          1st Floor, D.No: 027, Ward 25th, 2nd Cross, Annamalai Layout, Nalli
          Hospital Road, Erode – 638011
        </p>
      </div>
    </>
  );
}
